/**
 * Types for Ordering prompt form
 */

import type { UploadedDocument } from '../types';

export type { UploadedDocument };

// EAA-1741: per EAA-1104 spec, Ordering's Media field has no "Passage" option
// (unlike Multiple Choice Set / Matching) — only None/Image/Audio.
export type OrderingMediaType = 'none' | 'image' | 'audio';

export type OrderingSourceType = 'topic' | 'document';

export interface OrderingFormState {
    media: OrderingMediaType;
    // WHY: Prefer Agent recipe key num_items in state (GEN_QUESTION_CONTRACT_SSOT §3).
    num_items: number;
    sourceType: OrderingSourceType;
    description: string;
    documents: UploadedDocument[];
}

export const MEDIA_OPTIONS: { value: OrderingMediaType; label: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'image', label: 'Image' },
    { value: 'audio', label: 'Audio' },
];

// WHY: Bounds mirror Agent OrderingQuestionTypeConfig (ge=3, le=8, default=5).
// Do not use content-element player bounds — gen contract is Agent SoT.
export const MIN_ITEMS = 3;
export const MAX_ITEMS = 8;

export const DEFAULT_FORM_STATE: OrderingFormState = {
    media: 'none',
    num_items: 5,
    sourceType: 'topic',
    description: '',
    documents: [],
};

export const DOCUMENT_ACCEPT = '.pdf,.txt,.doc,.docx,.rtf';
